import { Injectable } from '@angular/core';
import { HttpService } from 'src/app/shared/service/http.service';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Session } from '../models/session.model';

@Injectable({
  providedIn: 'root'
})
export class HistoryService {
  constructor(private http: HttpService) {}

  getSessions(): Observable<Session[]> {
    return this.http.request('get', '/v1/user/sessions').pipe(
      map((response: any) => response.data),
      map((sessions: any[]) => sessions?.map((session) => new Session(session)))
    );
  }

  deleteSession(id: number): Observable<any> {
    return this.http.request('delete', `/v1/user/sessions?id=${id}`);
  }
}
